import { all } from "redux-saga/effects";
import { getApprovalFlowListWatcher,getApprovalFlowByIdWatcher,updateApprovalFlowWatcher,updateStagesWatcher,updateDocumentsWatcher,getApprovalListWatcher,getApprovalAcceptanceWatcher,addApprovalWorkFlowWatcher,addDocumentsWatcher,approverActionWatcher,addStagesWatcher,getAllUsersByRoleIdWatcher,addOriginatorsWatcher,getMainModulesWatcher,getSubModulesWatcher,getColumnsWatcher } from "./approval-workflow-saga";

export default function* approvalWorkFlowRootSaga() {
  yield all([
    addApprovalWorkFlowWatcher(),
    getAllUsersByRoleIdWatcher(),
    addOriginatorsWatcher(),
    getMainModulesWatcher(),
    getSubModulesWatcher(),
    getColumnsWatcher(),
    addDocumentsWatcher(),
    addStagesWatcher(),
    getApprovalListWatcher(),
    getApprovalAcceptanceWatcher(),
    approverActionWatcher(),
    getApprovalFlowListWatcher(),
    getApprovalFlowByIdWatcher(),
    updateApprovalFlowWatcher(),
    updateStagesWatcher(),
    updateDocumentsWatcher()
  ])}